<template>
  <div class="selector multi-selector">
    <div class="selector__content" @click="showOptions = !showOptions">
      <div class="selector__title">{{ title }}</div>
      <div class="selector__value">
        <span v-if="!selectedValues.length">{{ placeholder }}</span>
        <div v-else class="selector__value-selected">
          <div v-for="user in selectedValues" :key="user.id">
            <b v-html="user.value"></b>
            <br v-if="user.value && user.name" />
            <span>{{ user.name }}</span>
          </div>
        </div>
      </div>
      <div class="selector__arrow" :class="{ 'selector__arrow--open': showOptions }">
        <img src="@/assets/icons/icon-arrow.svg" alt="arrow" />
      </div>
    </div>
    <div v-if="showOptions" class="selector__options vk-selector">
      <div
        class="form-input selector__options-search"
        :class="[{ 'form-input--full': search }]"
        @click.stop
      >
        <input v-model="search" type="text" required @click.stop />
        <span class="form-input__label">
          {{ $t('search_props.placeholder') }}
        </span>
      </div>
      <div v-if="selectedValues && selectedValues.length" class="selector__options-item">
        <div @click="choseAll(false)">Убрать</div>
      </div>
      <div
        v-for="option in filtredOptions"
        :key="option.id"
        class="selector__options-item"
        :class="{ 'selector__options-item--active': checkStatus(option.id) }"
        @click="chooseOption(option)"
      >
        <div>
          <b v-if="option.description" v-html="option.description"></b>
          <br v-if="option.description && option.name" />
          <span>{{ option.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleSelector',
  props: {
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: null,
    },
    selected: {
      type: [String, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValues: [],
      showOptions: false,
      search: '',
    };
  },
  computed: {
    filtredOptions() {
      if (this.search && this.options) {
        return this.options.filter((el) => {
          const nameMatches = el.name && el.name.toLowerCase().includes(this.search.toLowerCase());
          const descriptionMatches =
            el.description && el.description.toLowerCase().includes(this.search.toLowerCase());
          return nameMatches || descriptionMatches;
        });
      } else if (this.options) {
        return this.options;
      }
      return null;
    },
  },
  methods: {
    checkStatus(id) {
      if (this.selectedValues) {
        const checked = this.selectedValues.findIndex((el) => el.id === id);
        return checked === -1 ? false : true;
      }
    },
    chooseOption(option) {
      if (option && option.id) {
        // Если ничего не выбрано
        if (!this.selectedValues || this.selectedValues.length === 0) {
          this.selectedValues = [{ ...option }];
        } else {
          // Если уже выбран этот же id — снять выбор
          const index = this.selectedValues.findIndex((el) => el.id === option.id);
          if (index !== -1) {
            this.removeOption(option.id);
          } else {
            // Заменить на новый выбор (одиночный селектор)
            this.selectedValues = [{ ...option }];
          }
        }
        this.$emit('handleChange', this.selectedValues);
        this.showOptions = false;
      }
    },
    removeOption(id) {
      const index = this.selectedValues.findIndex((el) => el.id === id);
      if (index !== -1) {
        this.selectedValues.splice(index, 1);
      }
    },
    choseAll(add) {
      this.$emit('handleDel', this.selectedValues);
      this.selectedValues = [];
      if (add) {
        this.options.forEach((el) => {
          this.selectedValues.push(el);
        });
      }
      this.$emit('handleChange', this.selectedValues);
    },
  },
  mounted() {
    // Добавляем обработчик клика по документу для закрытия селектора
    this.handleClickOutside = (e) => {
      // Проверяем, что клик не внутри текущего экземпляра селектора
      if (!this.$el.contains(e.target)) {
        this.showOptions = false;
      }
    };
    document.addEventListener('click', this.handleClickOutside, true);
  },
  beforeDestroy() {
    // Удаляем обработчик при уничтожении компонента
    document.removeEventListener('click', this.handleClickOutside, true);
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/helpers/variables';
@import '../../assets/styles/helpers/mixin';

.selector {
  &__content {
    padding-right: 3rem;
    min-height: 5rem;
    height: auto;
  }

  &__options {
    box-shadow: 0px 5px 10px 0px rgba(158, 158, 158, 0.1);
  }

  &__value {
    overflow: hidden;

    &-selected {
      display: flex;

      span {
        white-space: nowrap;
      }
    }
  }
}
</style>
